// rem-adapter.js
(function () {
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    return;
  }

  function setRemUnit() {
    var docEl = document.documentElement;
    var width = docEl.clientWidth || window.innerWidth;

    // <1200px 固定为 75，避免中小桌面继续放大导致布局溢出；
    // <=750px 保持移动端按宽度换算；
    // >=1200px 再做平滑缩放。
    var rem;
    if (width <= 750) {
      rem = width / 10;
    } else if (width < 1200) {
      rem = 75;
    } else {
      var desktopMinWidth = 1200;
      var desktopMaxWidth = 1920;
      var desktopMinRem = 75;
      var desktopMaxRem = 100;

      var clampedWidth = Math.min(Math.max(width, desktopMinWidth), desktopMaxWidth);
      var ratio = (clampedWidth - desktopMinWidth) / (desktopMaxWidth - desktopMinWidth);
      rem = desktopMinRem + (desktopMaxRem - desktopMinRem) * ratio;
    }

    docEl.style.fontSize = rem + 'px';
  }

  setRemUnit();
  window.addEventListener('resize', setRemUnit);
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) setRemUnit();
  });
})();
